<template>

<label class="d-block">{{label}}
  <v-select @search="onSearch" :value="value" @input="$emit('input', $event)" :options="options" :loading="loading" v-on:keyup.native.8="onBackspace"
            :get-option-label="labelGetter" :filterable="false" :placeholder="placeholder">
    <span slot="no-options">No se ha encontrado ningún registro</span>
  </v-select>
</label>

</template>

<script>

import {debounce} from 'lodash'

export default {
  name: 'ModelSelect',
  props: {
    value: {default: null},
    label: {type: String, default: null},
    placeholder: {type: String, default: null},
    modelLabel: {type: String, default: null},
    getOptionLabel: {type: Function, default: null},
    modelRequest: {type: Function, required: true}
  },
  created() {
    this.loading = true
    this.modelRequest()
      .then(models => { this.options = models })
      .finally(() => { this.loading = false })
  },
  data() {
    return {
      options: [],
      lastQuery: '',
      loading: false
    }
  },
  computed: {
    labelGetter() {
      return this.getOptionLabel || (model => model[this.modelLabel])
    }
  },
  methods: {
    onBackspace() {
      /*
        v-select won't emit the search event when the query is an empty string,
        so I have to natively capture the keyup event when the backspace key is pressed to delete the
        last character on the search query.
      */

      if (this.lastQuery.length === 1) {
        this.search('')
      }
    },
    onSearch(query) {
      this.lastQuery = query
      this.search(query)
    },
    search: debounce(function(query) {
      this.loading = true
      this.modelRequest(query)
        .then(models => { this.options = models })
        .finally(() => { this.loading = false })
    }, 1000)
  }
}

</script>



// WEBPACK FOOTER //
// src/components/common/ModelSelect.vue